import React, { useState } from 'react';

const SMTPConfigGuide = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <svg className="w-5 h-5 text-yellow-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="font-medium text-yellow-800">Configuration SMTP requise</h3>
        </div>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-yellow-600 hover:text-yellow-800 text-sm font-medium"
        >
          {isOpen ? 'Masquer' : 'Voir le guide'}
        </button>
      </div>

      {isOpen && (
        <div className="mt-4 space-y-4">
          <p className="text-sm text-yellow-700">
            Pour utiliser la télémaintenance automatique, vous devez configurer les paramètres SMTP dans le fichier <code className="bg-yellow-100 px-1 rounded">.env</code>
          </p>

          <div className="bg-white border rounded p-4">
            <h4 className="font-medium mb-2">📧 Configuration Gmail (recommandée)</h4>
            <div className="text-sm space-y-2">
              <div>
                <strong>1.</strong> Activez l'authentification à 2 facteurs sur votre compte Gmail
              </div>
              <div>
                <strong>2.</strong> Générez un mot de passe d'application :
                <ul className="ml-4 mt-1 list-disc text-xs text-gray-600">
                  <li>Allez dans les paramètres de votre compte Google</li>
                  <li>Sécurité → Authentification à 2 facteurs → Mots de passe des applications</li>
                  <li>Générez un nouveau mot de passe pour "Autre (nom personnalisé)"</li>
                </ul>
              </div>
              <div>
                <strong>3.</strong> Ajoutez ces lignes dans votre fichier <code className="bg-gray-100 px-1 rounded">.env</code> :
              </div>
              <pre className="bg-gray-800 text-white p-3 rounded text-xs overflow-x-auto mt-2">
{`SMTP_HOST=smtp.gmail.com
SMTP_PORT=587
SMTP_SECURE=false
SMTP_USER=votre-email@gmail.com
SMTP_PASS=votre-mot-de-passe-application
SMTP_FROM=votre-email@gmail.com`}
              </pre>
            </div>
          </div>

          <div className="bg-white border rounded p-4">
            <h4 className="font-medium mb-2">🏢 Configuration Outlook/Office 365</h4>
            <pre className="bg-gray-800 text-white p-3 rounded text-xs overflow-x-auto">
{`SMTP_HOST=smtp-mail.outlook.com
SMTP_PORT=587
SMTP_SECURE=false
SMTP_USER=votre-email@outlook.com
SMTP_PASS=votre-mot-de-passe
SMTP_FROM=votre-email@outlook.com`}
            </pre>
          </div>

          <div className="bg-white border rounded p-4">
            <h4 className="font-medium mb-2">🔧 Configuration personnalisée</h4>
            <div className="text-sm text-gray-600">
              Contactez votre administrateur système pour les paramètres SMTP de votre organisation.
              Les paramètres typiques incluent l'hôte, le port, et les identifiants de connexion.
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded p-3">
            <h4 className="font-medium text-blue-800 mb-1">💡 Test de configuration</h4>
            <p className="text-sm text-blue-700">
              Après avoir configuré SMTP, redémarrez le serveur et utilisez le bouton "Tester SMTP" 
              dans la configuration d'un client pour vérifier que l'envoi d'emails fonctionne.
            </p>
          </div>

          <div className="bg-red-50 border border-red-200 rounded p-3">
            <h4 className="font-medium text-red-800 mb-1">⚠️ Sécurité</h4>
            <p className="text-sm text-red-700">
              Ne partagez jamais vos identifiants SMTP. Utilisez des mots de passe d'application 
              plutôt que votre mot de passe principal. Le fichier .env ne doit jamais être commité 
              dans votre dépôt Git.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SMTPConfigGuide;